import { render } from "./FilamentIcon.vue?vue&type=template&id=3581fa90&scoped=true"
import script from "./FilamentIcon.vue?vue&type=script&lang=js"
export * from "./FilamentIcon.vue?vue&type=script&lang=js"

import "./FilamentIcon.vue?vue&type=style&index=0&id=3581fa90&scoped=true&lang=css"
import "./FilamentIcon.vue?vue&type=style&index=1&id=3581fa90&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3581fa90"]])

export default __exports__